var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.className,attrs:{"id":"mark-survey"}},[_c('Title',{attrs:{"ch":"社团总介绍","en":"general introduction"}}),_c('section',{ref:"survey",staticClass:"box"},_vm._l((_vm.data),function(ref,index){
var title = ref.title;
var content = ref.content;
return _c('DisplayCard',{key:index,attrs:{"index":index,"title":title,"type":2}},_vm._l((content),function(item,idx){return _c('p',{key:idx},[_vm._v(_vm._s(item))])}),0)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }